import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aae3f68c"
var script = {}
import style0 from "@/assets/css/sb-admin-2.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports